import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

import { SharedFunctions } from 'src/app/shared/shared.functions';

import { OrigenService } from 'src/app/shared/services';
import { MenuFuncionService } from 'src/app/shared/services/menuFuncion.service';

import { DialogConfirmRequest, DialogConfirmResponse, MenuFuncionCodes, Origen, SaveOrigenDto } from 'src/app/shared/model';
import { DialogConfirmComponent } from 'src/app/shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-origenEdit',
  templateUrl: './origenEdit.component.html',
  styles: [
  ]
})

export class OrigenEditComponent implements OnInit {
  formGroup: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;

  canView: boolean = false;
  canAdd: boolean = false;
  canEdit: boolean = false;
  canDelete: boolean = false;

  msgError: string = "";
  item: Origen;

  editingIndex: number | null = null;
  rangoEditTemp: any = null;

  constructor (
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private origenService: OrigenService) {
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.ORIGEN).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.isValidating = false;
        this.canEdit = data.Result.some(x => x == MenuFuncionCodes.ORIGEN_EDIT);
        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.ORIGEN_ADD);
        this.canView = data.Result.some(x => x == MenuFuncionCodes.ORIGEN_LIST);
        this.canDelete = data.Result.some(x => x == MenuFuncionCodes.ORIGEN_DELETE);
        this.loadView();
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();
    this.loadEntity();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'Codigo': [null, [Validators.required, Validators.maxLength(100)]],
      'Nombre': [null, [Validators.required, Validators.maxLength(100)]],
      'CostoAlmacenaje': [null],
      'DiasAlmacenaje': [null],
      'Handling': [null, Validators.required],
      'Activo': [true, Validators.required]
    });
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isDeleting);
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        var id = Number(params['id']);

        if (id > 0) {
          if (this.canView || this.canEdit) {
            this.isSearching = true;
            this.origenService.get(id).subscribe(data => {
              this.isSearching = false;
              if (data != null && data.Success) {
                this.item = data.Result;

                if (this.item != null && this.item.Id > 0) {

                  if (!this.item.Rangos) {
                    this.item.Rangos = [];
                  }

                  this.formGroup.patchValue(this.item);
                }
                else
                  this.msgError = "No se encontró el origen seleccionado.";
              }
              else
                this.msgError = "Ocurrió un error al intentar obtener los datos del origen.";
            },
            (err: HttpErrorResponse) => {
              this.isSearching = false;
              this.sharedFunctions.handleError(err, true);
            })
          }
          else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.onCancel();
          }
        }
        else
          this.msgError = "Item no válido.";
      }
      else {
        if (this.canAdd) {
          this.item = new Origen(0, null, null, 0, null, null, true, null);
          this.formGroup.patchValue(this.item);
        }
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.onCancel(); 
        }
      }
    });
  }

  getErrorCodigo() {
    var v = this.formGroup.get('Codigo');
    if (v.hasError('required'))
      return 'El campo es obligatorio';
    if (v.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorNombre() {
    var v = this.formGroup.get('Nombre');
    if (v.hasError('required'))
      return 'El campo es obligatorio';
    if (v.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }  

  getErrorCostoAlmacenaje() {
    return this.formGroup.get('CostoAlmacenaje').hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorDiasAlmacenaje() {
    return this.formGroup.get('DiasAlmacenaje').hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorHandling() {
    return this.formGroup.get('Handling').hasError('required') ? 'El campo es obligatorio' :'';
  }

  onGuardar() {

    if (this.editingIndex !== null) {
      this.sharedFunctions.showMessage("Debe confirmar o cancelar la edición de la banda actual", "Advertencia");
      return;
    }

    var codigoFormField = this.formGroup.get("Codigo");
    if (codigoFormField.value == null || codigoFormField.value.length == 0)
      this.formGroup.get("Codigo").setValue(this.formGroup.get("Nombre").value);

    var nombreFormField = this.formGroup.get("Nombre");
    if (nombreFormField.value == null || nombreFormField.value.length == 0)
      this.formGroup.get("Nombre").setValue(this.formGroup.get("Codigo").value);
    
    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    if (!this.item.Rangos || this.item.Rangos.length === 0) {
      this.sharedFunctions.showMessage("Debe ingresar al menos una banda de costo", "Error");
      return;
    }

    var r = new SaveOrigenDto(null, null, 0, 0, 0, true, null);

    r = 
    {
      ...this.formGroup.value,
      ...
      {
        Id: (this.item?.Id ?? 0),
        Activo: this.item.Activo,
        Rangos: this.item.Rangos
      }
    };

    this.isSaving = true;
    this.origenService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onDelete() {
    if (!this.canDelete)
        return false;

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(null, "¿Está seguro que desea eliminar el item?", null, null)
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isDeleting = true;
        this.origenService.delete(this.item.Id).subscribe(data => {
          this.isDeleting = false;
          if (data != null && data.Success && data.Result) {
            this.sharedFunctions.showMessage("Se eliminaron correctamente los datos!", "Operación Exitosa!");
            this.onCancel();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isDeleting = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    });
  }

  onCancel() {
    this.location.back();
  }

  agregarRango() {
    if (this.editingIndex !== null) return;

    if (!this.item.Rangos) {
      this.item.Rangos = [];
    }
    
    this.item.Rangos.push({ Id: 0, PesoDesde: null, PesoHasta: null, Costo: null });
    this.editarRango(this.item.Rangos.length - 1);
  }

  editarRango(index: number){
    this.editingIndex = index;
    this.rangoEditTemp = { ...this.item.Rangos[index] };
  }

  guardarEdicionRango(index: number) {
    const temp = this.rangoEditTemp;

    if (temp.Costo == null) {
      this.sharedFunctions.showMessage("El campo Costo es obligatorio", "Advertencia");
      return;
    }

    if (temp.PesoDesde === null || temp.PesoDesde === undefined || temp.PesoDesde === '') {
      const yaExisteNullDesde = this.item.Rangos.some((r, i) => i !== index && (r.PesoDesde === null || r.PesoDesde === undefined));
      if (yaExisteNullDesde) {
        this.sharedFunctions.showMessage("Ya existe un rango que comienza desde el mínimo.", "Error");
        return;
      }
      temp.PesoDesde = null; 
    }

    if (temp.PesoHasta === null || temp.PesoHasta === undefined || temp.PesoHasta === '') {
      const yaExisteNullHasta = this.item.Rangos.some((r, i) => i !== index && (r.PesoHasta === null || r.PesoHasta === undefined));
      if (yaExisteNullHasta) {
        this.sharedFunctions.showMessage("Ya existe un rango que termina en el máximo.", "Error");
        return;
      }
      temp.PesoHasta = null; 
    }

    if (temp.PesoDesde !== null && temp.PesoHasta !== null) {
      if (temp.PesoDesde >= temp.PesoHasta) {
        this.sharedFunctions.showMessage("El peso inicial debe ser menor al peso final.", "Error");
        return;
      }
    }

    const existeSolapamiento = this.item.Rangos.some((r, i) => {
      if (i === index) return false; 

      const d1 = temp.PesoDesde ?? -Infinity;
      const h1 = temp.PesoHasta ?? Infinity;
      const d2 = r.PesoDesde ?? -Infinity;
      const h2 = r.PesoHasta ?? Infinity;

      return (d1 <= h2 && h1 >= d2);
    });

    if (existeSolapamiento) {
      this.sharedFunctions.showMessage("Conflicto: Este rango se solapa con uno ya existente.", "Error");
      return;
    }

    this.item.Rangos[index] = { ...temp };

    this.editingIndex = null;
    this.rangoEditTemp = null;
  }

  cancelarEdicionRango() {
    if (this.item.Rangos[this.editingIndex].Id === 0 && this.item.Rangos[this.editingIndex].PesoDesde == null) {
      this.item.Rangos.splice(this.editingIndex, 1);
    }
    this.editingIndex = null;
    this.rangoEditTemp = null;
  }

  eliminarRango(index: number) {
    this.item.Rangos.splice(index, 1);
  }
}
